import { z } from "zod";
import { zUid } from "./zUid";

// Пара "разрешённая комбинация": когда у ограничивающего (master) атрибута
// выбрано значение restrictionId, у ограничиваемого (slave) разрешено sourceId.
// Осторожно с названиями: sourceId - значение ограничиВАЕМОГО справочника,
// restrictionId - значение ограничиВАЮЩЕГО (см. restrictionUtils, getAllowedSourceIds)
export const zValueRestriction = z.object({
  sourceId: zUid, // значение slave-справочника (разрешённое)
  restrictionId: zUid, // значение master-справочника (при котором разрешено)
});
export type ZValueRestriction = z.infer<typeof zValueRestriction>;

// Ограничение хранится на стороне ограничиваемого (slave) атрибута:
// GET/PUT/DELETE /attributes/{slaveAttrId}/restrictions
export const zRestriction = z.object({
  // id ограничивающего (master) АТРИБУТА, не справочника: по нему компоненты
  // делают Form.useWatch (имена полей формы = String(attr.id)).
  // В админской модели это поле называется masterAttrId (см. EdAttribute)
  restrictionAttributeId: zUid,
  values: zValueRestriction.array(),
});
export type ZRestriction = z.infer<typeof zRestriction>;
